<!--
* @Name：议价审批模具分摊
* @Author: 刘玉
* @Date: 2021-12-02 15:43:31
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.bargainItemId" :row-index="index + 1">
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>模具分摊总金额：</span>
        <span>{{ getSumMouldExpense(item) }}</span>
      </van-row>
      <van-row>
        <span>模具分摊数量：</span>
        <span>{{ item.mouldExpense }}</span>
      </van-row>
      <van-row>
        <span>模具分摊价格：</span>
        <span>{{ item.amountHasAmortized }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'MoldAllocated',
  data() {
    return {
      detailsVisible: false
    }
  },
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getSumMouldExpense(item) {
      if (item.mouldExpense && item.amountHasAmortized) {
        return Number(item.mouldExpense) * Number(item.amountHasAmortized)
      } else {
        return ''
      }
    }
  }
}
</script>
